// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FilterButton-module__baseButton___4NBwp {\n    padding: 8px 9px;\n    font-size: 14px;\n    border-radius: 5px;\n    border: solid 1px #B1AFAB;\n}\n\n.FilterButton-module__selected___-pM56 {\n    background-color: #ffe7b7;\n    color: #FF9100;\n    font-weight: 600;\n    border: solid 1px #FF9100;\n}\n\n.FilterButton-module__default___OjqX3 {\n    color: #B1AFAB;\n    font-weight: 600;\n    border: solid 1px #B1AFAB;\n    background-color: #fff;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"baseButton": "FilterButton-module__baseButton___4NBwp",
	"selected": "FilterButton-module__selected___-pM56",
	"default": "FilterButton-module__default___OjqX3"
};
export default ___CSS_LOADER_EXPORT___;
